import React from 'react'
import PropTypes from 'prop-types'
import style from './Style.css'
import CenterSpinner from '../CenterSpinner'

const ModalLoader = ({children, isLoading}) => {
	if(!isLoading){
		return children
	}else{
		return (
			<div className={style.component}>
				{children}
				<div className={style.modal}>
					<CenterSpinner size="50px"/>
				</div>
			</div>
		)
	}
}

ModalLoader.propTypes = {
	isLoading: PropTypes.bool,
	children: PropTypes.node
}

ModalLoader.defaultProps = {
	isLoading: false
}

export default ModalLoader



// WEBPACK FOOTER //
// ./client/components/layout/ModalLoader/index.js